import React, { useEffect, useState } from "react";
import styles from "./toggleStyles.module.css";
import MoonIcon from "../../../media/images/icons/toggle-moon.svg";
import MoonSVG from "../../../media/images/icons/moondark.svg";
import SunIcon from "../../../media/images/icons/toggle-sun.svg";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import { setThemeMode } from "../../../redux/features/settingSlice";
export default function ThemeToggle() {
  const themeMode = useAppSelector((state) => state.settings.themeMode);

  const [toggle, setToggle] = useState(themeMode === "dark");

  const dispatch = useAppDispatch();

  const handleTheme = () => {
    if (themeMode === "light") {
      dispatch(setThemeMode("dark"));
    } else {
      dispatch(setThemeMode("light"));
    }
  };

  useEffect(() => {
    setToggle(themeMode === "dark");
  }, [themeMode]);

  return (
    <button
      style={{
        backgroundColor: toggle ? "#444444" : "#CFD8DC",
      }}
      className={`${styles.toggle_btn} ${toggle ? styles.toggled : ""}`}
      onClick={() => handleTheme()}
    >
      <div className={`${!toggle ? styles.thumbLight : styles.thumbDark}`}>
        <img
          className={`${
            toggle ? styles.sunTrackActive : styles.sunTrackInActive
          }`}
          width={14}
          src={MoonSVG}
          alt=""
        />
        <img
          className={`${
            toggle ? styles.moonTrackInActive : styles.moonTrackActive
          }`}
          width={14}
          src={SunIcon}
          alt=""
        />
      </div>

      <img
        className={`${
          toggle ? styles.moonTrackInActive : styles.moonTrackActive
        }`}
        width={14}
        src={MoonIcon}
        alt=""
      />
      <img
        className={`${
          toggle ? styles.sunTrackActive : styles.sunTrackInActive
        }`}
        width={14}
        src={SunIcon}
        alt=""
      />
    </button>
  );
}
